module.exports = __webpack_public_path__ + "static/media/profile-picture.c23319ce.jpg";